module.exports = __webpack_public_path__ + "media/images/ready/icon-brain-6223afbe4ad220dab275c232e99bbbac.svg";